import { RootState } from '../store';

export const selectMyProfileSidebarState = (state: RootState) => state.myProfileSidebar;
